import DefaultInput from 'components/input/DefaultInput';
import React from 'react';
import styled from 'styled-components';
import { theme } from 'utils/style/theme';
import { ILangDataList } from 'utils/types/common';
/**
 * * 판매 관리 : 코인 상점 등록 & 수정 다국어 폼
 */
interface IProps {
  title: string;
  langList?: ILangDataList[];
  onChange?: (e: any) => void;
}
const CoinStoreLocalizingInputForm = ({
  title,
  onChange,
  langList,
}: IProps) => {
  return (
    <LocalizingForm>
      <h1>{title}</h1>
      {langList?.map((v) => (
        <DefaultInput
          name='name'
          id={`${v.lang}`}
          value={v.name}
          onChange={onChange}
          codeName={v.code_name ? v.code_name : ''}
          //   maxLength={60}
          localizing
        />
      ))}
    </LocalizingForm>
  );
};

export default CoinStoreLocalizingInputForm;
const LocalizingForm = styled.form`
  h1 {
    color: ${theme.colors.blue_7};
    font-size: ${theme.fontSizes.md};
    font-weight: 700;
    margin-bottom: 1rem;
    margin-left: 0.6rem;
  }
  .section_input {
    border-bottom: 1px solid rgba(217, 222, 227, 0.5);
    margin-bottom: 4rem;
    padding-bottom: 2.5rem;
  }
`;
